<template>
  <div
   :class="[themeClassOrDefault]"
    class="md-menu-content"
    @keydown.esc.prevent="close"
    @keydown.tab.prevent="close"
    @keydown.up.prevent="highlightItem('up')"
    @keydown.down.prevent="highlightItem('down')"
    @keydown.enter="fireClick"
    @keydown.space="fireClick"
    tabindex="-1">
    <md-list>
      <slot></slot>
    </md-list>
  </div>
</template>

<script>
  import theme from '../../core/theme/mixins';

  export default {
    name: 'md-menu-content',
    data() {
      return {
        oldHighlight: false,
        highlighted: false,
        itemListCount: 0,
        menuItems: []
      };
    },
    mixins: [theme],
    methods: {
      close() {
        this.highlighted = false;
        this.$parent.close();
      },
      registerItem(item) {
        this.menuItems.push(item);
      },
      unregisterItem(item) {
        this.menuItems = this.menuItems.filter( i => i!== item);
      },
      highlightItem(direction) {
        if (this.menuItems.length < this.highlighted - 1) {
          this.highlighted = 1;
        }
        if (this.highlighted < -1 ){
          this.highlighted = false;
        }

        this.oldHighlight = this.highlighted;

        if (direction === 'up') {
          if (this.highlighted === 1) {
            this.highlighted = this.menuItems.length;
          } else {
            this.highlighted--;
          }
        }

        if (direction === 'down') {
          if (this.highlighted === this.menuItems.length) {
            this.highlighted = 1;
          } else {
            this.highlighted++;
          }
        }
        if (this.highlighted - 1 >=0 && this.highlighted - 1 < this.menuItems.length) {
          this.menuItems[this.highlighted - 1].$el.scrollIntoView({
            block: 'nearest', behavior: 'smooth'
          });

          for (var i = 0; i < this.menuItems.length; i++) {
            this.menuItems[i].highlighted = false;
          }

          this.menuItems[this.highlighted - 1].highlighted = true;
        }
      },
      fireClick() {
        if (this.highlighted > 0) {
          this.getOptions()[this.highlighted - 1].$el.click();
        }
      },
      getOptions() {
        return this.menuItems.filter((child) => {
          return child.$el.classList.contains('md-option');
        });
      },
      getSelectedIndex() {
        if (this.highlighted - 1 >=0 && this.highlighted - 1 < this.menuItems.length) {
          return this.menuItems[this.highlighted - 1].index;
        }
        return false;
      }
    },
    mounted() {
      if (!this.$parent.$el.classList.contains('md-menu')) {
        // this.$destroy();

        throw new Error('You must wrap the md-menu-content in a md-menu');
      }
    }
  };
</script>
